import * as React from "react";
import { forwardRef } from "react";
const SvgIcWorks16 = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("g", { id: "ic-works-16" }, /* @__PURE__ */ React.createElement("path", { id: "Vector", fillRule: "evenodd", clipRule: "evenodd", d: "M9.64274 0L14.0483 14H15V16H1V14H1.95165L6.35724 0H9.64274ZM7.50988 3H8.49011L9.43417 6H6.56582L7.50988 3ZM5.62176 9H10.3782L11.3223 12H4.67771L5.62176 9Z", fill: "currentColor" })));
const ForwardRef = forwardRef(SvgIcWorks16);
export { ForwardRef as ReactComponent };
